import { useDocusignUpdateConsentedIntegration } from "@/orval/gen"
import { showSuccessNotification } from "@/utils/form-submission-notifications"
import { Center, Loader } from "@mantine/core"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/app/admin-settings/global-settings/docusign/consented"
)({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { mutate: setConsentedIntegration } =
    useDocusignUpdateConsentedIntegration({
      mutation: {
        onSuccess: () => {
          navigate({ to: "/app/admin-settings/global-settings" })
          showSuccessNotification("Docusign Integration consented")
        },
      },
    })
  React.useEffect(() => {
    setConsentedIntegration()
  }, [])

  return (
    <Center h={"100%"}>
      <Loader />
    </Center>
  )
}
